import React from 'react';
import PropTypes from 'prop-types';

import t from '../../lib/I18n';

import TicketOffice from '../../records/TicketOffice';
import Loading from '../general/Loading';

const days = [
    'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'
];

export default function OpeningHours ({ ticketOffice, loadingTicketOfficeDetails }) {
    const getHours = (day) => {
        const timeslots = ticketOffice.openingHours.get(day);
        return timeslots.size
            ? timeslots.join(', ')
            : t('stationFinder.modal.openingHours.unknown');
    };

    const noHours = !loadingTicketOfficeDetails && ticketOffice ? ticketOffice.hasNoHours() : undefined;

    if (loadingTicketOfficeDetails || ticketOffice) {
        return (
            <div className='stationFinder__modal-details stationFinder__modal-opening-hours'>
                <h3>{ t('stationFinder.modal.openingHours') }</h3>
                    { loadingTicketOfficeDetails &&
                        <Loading inline message="stationFinder.modal.openingHoursChecking" /> }
                    { !loadingTicketOfficeDetails && ticketOffice && noHours &&
                        <div className="margin-bottom--sm">
                            { t('stationFinder.modal.openingHoursNotAvailable') }
                        </div> }
                    { !loadingTicketOfficeDetails && ticketOffice && !noHours &&
                        (<table className="table margin-bottom--sm">
                            <tbody>
                                { days.map(day => (
                                    <tr key={ day }>
                                        <th>{ day }</th>
                                        <td>{ getHours(day) }</td>
                                    </tr>
                                )) }
                            </tbody>
                        </table>) }
            </div>
        );
    }

    return null;
}


OpeningHours.propTypes = {
    ticketOffice: PropTypes.instanceOf(TicketOffice),
    loadingTicketOfficeDetails: PropTypes.bool
};

OpeningHours.defaultProps = {
    ticketOffice: null,
    loadingTicketOfficeDetails: false
};



// WEBPACK FOOTER //
// ./src/components/stationFinder/OpeningHours.js